import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  findDataInFields,
  removeTrailingZerosUntil2,
  findDataInObject,
  calculateDateDiffWithGrace,
  calculateDateDiff,
  classNames,
} from "../../utils/helperFuctions";
import axios from "axios";
import { getCookie } from "../../utils/cookieHandler";
import { config } from "../../utils/config";

const isTaxed = (val) =>
  val === true || val === "true" || val === 1 || val === "1";

const SummaryList = ({ options, handleChange }) => {
  const currentFields = useSelector((state) => state.showFields);

  const branchId = findDataInFields(currentFields, "branch.id");

  const [customerTotalBalance, setCustomerTotalBalance] = useState({
    loading: true,
    value: null,
  });
  const [customerTotalDepositBalance, setCustomerTotalDepositBalance] =
    useState({
      loading: true,
      value: null,
    });

  const currency = findDataInFields(currentFields, "currency.name");
  const initData = () => {
    const temp = {};
    if (options) {
      temp.mainTitle = options.mainTitle;
      temp.sublists = processList(options.sublists);
      let sumlistP = sumVat(temp.sublists);
      let sumlist = sumNumber(temp.sublists);

      if (options.tax) {
        const taxAmount =
          (sumlistP *
            parseFloat(
              processProperties(
                options.tax.number
                  ? options.tax.number
                      .split(",")
                      .map((property) => property.trim())
                  : []
              )
            )) /
            100 || 0;
        sumlist += taxAmount;

        temp.sublists.push({
          title: options.tax ? options.tax.title : "",
          items: [
            {
              title: processProperties(
                options.tax.subtitle
                  ? options.tax.subtitle
                      .split(",")
                      .map((property) => property.trim())
                  : []
              ),
              amount:
                processProperties(
                  options.tax.amount
                    ? options.tax.amount
                        .split(",")
                        .map((property) => property.trim())
                    : []
                ) +
                " " +
                taxAmount,
              number: parseFloat(taxAmount).toFixed(2),
            },
          ],
        });
      }
      if (
        (sumlist < 0 && sumlist > -0.008) ||
        (sumlist > 0 && sumlist < 0.008)
      ) {
        sumlist = 0;
      }
      temp.total = {
        label: options.total.label ?? "Total",
        value: sumlist.toFixed(2),
      };

      temp.depositTotal = {
        label: options.depositTotal.label ?? "Deposit Total",
        value: sumDeposit(temp.sublists).toFixed(2),
      };

      // temp.customerTotal = {
      //   label: options.customerTotal.label ?? "Customer Total",
      //   value: getCustomerTotalBalance(),
      // };
    }

    return temp;
  };

  const sumNumber = (list, onlyPositive) => {
    let sum = 0.0;

    if (Array.isArray(list)) {
      list.forEach((subl) => {
        if (Array.isArray(subl.items)) {
          let i = 0;
          sum += subl.items.reduce((acc, obj) => {
            const num = parseFloat(obj.number);
            const isValidNumber = !isNaN(num) && !obj.isDeposit;

            if (!isValidNumber) return acc;

            let value = onlyPositive ? (num > 0 ? num : 0) : num;
            if (
              obj.adjustmentType === "" &&
              obj.dateExtended != null &&
              obj.dateExtended !== ""
            ) {
              const previousItemAddedDate =
                subl.items.length > 1 && i !== 0
                  ? subl.items[i - 1].dateExtended
                  : findDataInFields(currentFields, "return_date");

              if (
                new Date(previousItemAddedDate) > new Date(obj.dateExtended)
              ) {
                obj.adjustmentType = "REDUCTION";
              } else {
                obj.adjustmentType = "EXTENSION";
              }
            }
            const isDeduct =
              (obj.deduct != null && obj.deduct === true) ||
              obj.deduct === "true" ||
              obj?.adjustmentType === "REDUCTION";
            i++;
            return acc + (isDeduct ? -value : value);
          }, 0);
        }
      });
    }

    return sum;
  };

  const sumVat = (list) => {
    let sum = 0.0;
    if (Array.isArray(list)) {
      list.forEach((subl) => {
        if (Array.isArray(subl.items)) {
          subl.items.forEach((obj, i) => {
            if (
              obj.adjustmentType === "" &&
              obj.dateExtended != null &&
              obj.dateExtended !== ""
            ) {
              const previousItemAddedDate =
                subl.items.length > 1 && i !== 0
                  ? subl.items[i - 1].dateExtended
                  : findDataInFields(currentFields, "return_date");

              if (
                new Date(previousItemAddedDate) > new Date(obj.dateExtended)
              ) {
                obj.adjustmentType = "REDUCTION";
              } else {
                obj.adjustmentType = "EXTENSION";
              }
            }
            const numberVal = parseFloat(obj.number);
            if (
              isNaN(numberVal) ||
              (obj.taxable !== "true" && obj.vat === false) ||
              obj.taxable === "false" ||
              obj.taxable === "undefined"
            ) {
              // do nothing
            } else {
              if (obj.title === "Discount") {
                // handled separately in allDiscounts below
              } else {
                const isDeduct =
                  (obj.deduct != null && obj.deduct === true) ||
                  obj.deduct === "true" ||
                  obj?.adjustmentType === "REDUCTION";
                sum += isDeduct ? -numberVal : numberVal;
              }
            }
          });
        }
      });
    }

    const allDiscounts = list
      .flatMap((entry) => (Array.isArray(entry.items) ? entry.items : []))
      .filter(
        (it) => it.title === "Discount" || it.title === "Additional Discount"
      );

    if (Array.isArray(allDiscounts) && allDiscounts.length > 0) {
      const totalDiscount = allDiscounts.reduce((acc, item) => {
        return (
          acc +
          Math.abs(
            isNaN(parseFloat(item.number || 0))
              ? 0
              : parseFloat(item.number || 0)
          )
        );
      }, 0);

      const sumDiscountedTaxable = sum - totalDiscount;
      if (sumDiscountedTaxable <= 0) {
        return 0;
      }

      return sumDiscountedTaxable;
    }

    return sum;
  };

  const sumDeposit = (list, onlyPositive) => {
    let sum = 0.0;
    if (Array.isArray(list)) {
      list.forEach((subl) => {
        if (Array.isArray(subl.items)) {
          sum += subl.items.reduce((acc, obj) => {
            const num = parseFloat(obj.number);
            if (
              obj.isDeposit === true &&
              (obj.ignore === true || obj.ignore === "true")
            )
              return 0;
            if (isNaN(num) || !obj.isDeposit) return acc;

            let value = num;

            if (onlyPositive && value <= 0) return acc;

            if (obj.isNegative === true) {
              value *= -1;
            }

            return acc + value;
          }, 0);
        }
      });
    }

    return sum;
  };

  const processProperties = (properties, searchObject) => {
    let concat = "";
    // console.log(properties);

    for (const prop_ in properties) {
      const prop = properties[prop_];
      if (prop.includes("<s>")) {
        let _prop = prop.replace("<s>", "");
        concat += _prop;
      } else if (prop.includes("<days>")) {
        let _prop = prop.replace("<days>", "");
        const tempProps = _prop.split("~");
        if (tempProps.length === 2) {
          const date1 =
            searchObject && findDataInObject(searchObject, tempProps[0]) !== ""
              ? findDataInObject(searchObject, tempProps[0])
              : findDataInFields(currentFields, tempProps[0]);
          const date2 = searchObject
            ? findDataInObject(searchObject, tempProps[1])
            : findDataInFields(currentFields, tempProps[1]);

          const grace_period = findDataInFields(currentFields, "grace_period");
          let gp = grace_period;

          if (gp == null || gp === "") {
            const graceperiod = findDataInFields(
              currentFields,
              "branch.grace_period"
            );
            gp = graceperiod;
          }

          if (searchObject?.date_extended != null) {
            let d1 = date1;

            let d2 = date2;
            // console.log(d2, index, "d2");

            if (d2.endsWith("Z") === true) {
              d2 = d2.substring(0, d2.length - 1);
            }

            concat += calculateDateDiff(d1, d2);
          } else {
            concat += calculateDateDiffWithGrace(date1, date2, gp);
          }
        }
      } else if (prop.includes("<day>")) {
        let _prop = prop.replace("<day>", "");
        const day = searchObject
          ? findDataInObject(searchObject, _prop)
          : findDataInFields(currentFields, _prop);

        concat += day;
      } else if (prop.trim() === "") {
        concat += " ";
      } else if (prop.includes("<date>")) {
        let _prop = prop.replace("<date>", "");
        concat += findDataInObject(searchObject, _prop);
      } else {
        const hasFields = prop.includes("<fields>");
        let _prop = hasFields ? prop.replace("<fields>", "") : prop;
        const isDecimal = prop.includes("<d>");
        _prop = isDecimal ? prop.replace("<d>", "") : _prop;
        const amount = removeTrailingZerosUntil2(
          searchObject && !hasFields
            ? findDataInObject(searchObject, _prop)
            : findDataInFields(currentFields, _prop),
          2,
          isDecimal
        );

        concat += isNaN(parseFloat(amount)) ? amount : parseFloat(amount);
      }
    }

    return concat;
  };
  const processList = (options) => {
    if (Array.isArray(options)) {
      const results = options.map((sl) => {
        const result = { title: sl.title, items: [] };

        if (Array.isArray(sl.items)) {
          result.items = sl.items.map((ssl) => {
            const ssres = {};
            const titleProperties = ssl.title
              ? ssl.title.split(",").map((property) => property.trim())
              : [];

            if (titleProperties.length > 0) {
              ssres.title = processProperties(titleProperties);
            }
            //
            const daysCountProperties = ssl.daysCount
              ? ssl.daysCount.split(",").map((property) => property.trim())
              : [];
            if (daysCountProperties.length > 0) {
              ssres.daysCount = processProperties(daysCountProperties);
            }
            //
            //

            // const taxable = ssl.taxable
            //   ? ssl.taxable.split(",").map((property) => property.trim())
            //   : [];
            // if (taxable.length > 0) {
            //   ssres.taxable = processProperties(taxable);
            // }
            //
            const amountProperties = ssl.amount
              ? ssl.amount.split(",").map((property) => {
                  return property.trim();
                })
              : [];
            if (amountProperties === "vat") {
              ssres.amount = 222;
            } else if (amountProperties.length > 0) {
              ssres.amount = processProperties(amountProperties);
            }

            const numberProperties = ssl.number
              ? ssl.number.split(",").map((property) => property.trim())
              : [];
            if (numberProperties.length > 0) {
              ssres.number = processProperties(numberProperties) || 0;
            }
            const adjustmentTypeProperties = ssl.adjustmentType
              ? ssl.number.split(",").map((property) => property.trim())
              : [];
            if (adjustmentTypeProperties.length > 0) {
              ssres.adjustmentType =
                processProperties(adjustmentTypeProperties) || 0;
            }
            const dateExtendedProperties = ssl.dateExtended
              ? ssl.number.split(",").map((property) => property.trim())
              : [];
            if (dateExtendedProperties.length > 0) {
              ssres.dateExtended =
                processProperties(dateExtendedProperties) || 0;
            }
            ssres.vat = ssl.vat ? true : false;
            ssres.isDeposit = ssl.isDeposit ? true : false;
            ssres.isNegative = ssl.isNegative ? true : false;
            ssres.ignore = ssl.ignore ? true : false;

            return ssres;
          });
        }
        if (sl.isArray && sl.arrayParam && sl.arrayitems) {
          const relatedField = currentFields.find(
            (x) => x.name === sl.arrayParam
          );

          if (relatedField && Array.isArray(relatedField.defaultValue)) {
            const titleProperties = sl.arrayitems.title
              ? sl.arrayitems.title
                  .split(",")
                  .map((property) => property.trim())
              : [];
            const taxableProperties = sl.arrayitems.taxable
              ? sl.arrayitems.taxable
                  .split(",")
                  .map((property) => property.trim())
              : [];
            const adjustmentTypeProperties = sl.arrayitems.adjustmentType
              ? sl.arrayitems.adjustmentType
                  .split(",")
                  .map((property) => property.trim())
              : [];
            const dateExtendedProperties = sl.arrayitems.dateExtended
              ? sl.arrayitems.dateExtended
                  .split(",")
                  .map((property) => property.trim())
              : [];
            const deductProperties = sl.arrayitems.deduct
              ? sl.arrayitems.deduct
                  .split(",")
                  .map((property) => property.trim())
              : [];

            const amountProperties = sl.arrayitems.amount
              ? sl.arrayitems.amount
                  .split(",")
                  .map((property) => property.trim())
              : [];
            const numberProperties = sl.arrayitems.number
              ? sl.arrayitems.number
                  .split(",")
                  .map((property) => property.trim())
              : [];
            const deleteProperties = sl.arrayitems.delete
              ? sl.arrayitems.delete
                  .split(",")
                  .map((property) => property.trim())
              : [];
            const conditionProperties = sl.condition
              ? sl.condition.compareWith
                ? sl.condition.compareWith
                    .split(",")
                    .map((property) => property.trim())
                : []
              : [];
            const isVat = sl.arrayitems.vat ? true : false;
            relatedField.defaultValue.forEach((element) => {
              let numberMultiply = "";
              let conditionProp = "";
              if (conditionProperties.length > 0) {
                if (Array.isArray(sl.condition.values)) {
                  conditionProp =
                    conditionProperties.length > 0
                      ? processProperties(conditionProperties, element)
                      : "";
                  const fintTemp = sl.condition.values.find(
                    (x) => x.name === conditionProp
                  );
                  switch (fintTemp?.operation) {
                    case "subtract":
                      numberMultiply = "-";
                      break;
                    // case 'none':
                    //   numberMultiply = '0'
                    //   break;
                    default:
                      break;
                  }
                }
              }
              const isDeleted =
                deleteProperties.length > 0
                  ? processProperties(deleteProperties, element)
                  : "";
              if (
                isDeleted !== "true" &&
                isDeleted !== true &&
                element.delete !== "true" &&
                element.delete !== true
              ) {
                result.items.push({
                  title:
                    titleProperties.length > 0
                      ? processProperties(titleProperties, element)
                      : "",
                  amount:
                    amountProperties.length > 0
                      ? processProperties(amountProperties, element)
                      : "",
                  number:
                    numberProperties.length > 0
                      ? numberMultiply +
                        processProperties(numberProperties, element)
                      : 0,
                  isDeposit:
                    conditionProp === "Security Deposit Payment" ||
                    conditionProp === "Security Deposit Refund",
                  isRefund:
                    conditionProp === "Reservation Refund" ||
                    conditionProp === "Security Deposit Refund",
                  vat: isVat,
                  deduct:
                    deductProperties.length > 0
                      ? processProperties(deductProperties, element)
                      : null,
                  taxable:
                    taxableProperties.length > 0
                      ? processProperties(taxableProperties, element)
                      : "",
                  adjustmentType:
                    adjustmentTypeProperties.length > 0
                      ? processProperties(adjustmentTypeProperties, element)
                      : "",
                  dateExtended:
                    dateExtendedProperties.length > 0
                      ? processProperties(dateExtendedProperties, element)
                      : "",
                });
              }
            });
          }
        }

        return result;
      });
      return results;
    }
    return [];
  };
  const data = initData();
  // incase of something going wrong later
  // const [data, setData] = useState();

  // useEffect(() => {
  //   setData();
  // }, currentFields);

  useEffect(() => {
    if (options?.total?.param && data?.total?.value) {
      const oldrelParam = currentFields.find(
        (x) => x.name === options.total.param
      );
      const others = [];
      if (oldrelParam?.defaultValue !== data.total.value) {
        // contact balance calculation on the fly
        const oldValue = parseFloat(oldrelParam.defaultValue);
        const newValue = parseFloat(data.total.value);
        const currentBalance = customerTotalBalance.value;
        if (currentBalance != null) {
          const customerBalanceNewValue = currentBalance - oldValue + newValue;

          handleChange(
            {
              target: {
                name: "contact_balance",
                value: customerBalanceNewValue,
              },
            },
            false
          );

          setCustomerTotalBalance((prev) => ({
            ...prev,
            value: customerBalanceNewValue,
          }));
        }
        if (
          options?.depositTotal?.param &&
          !isNaN(parseInt(data?.depositTotal?.value))
        ) {
          const oldrelParam = currentFields.find(
            (x) => x.name === options.depositTotal.param
          );

          if (oldrelParam?.defaultValue !== data.depositTotal.value) {
            others.push({
              target: {
                name: options.depositTotal.param,
                value: data.depositTotal.value,
              },
            });
          }
        }

        handleChange(
          {
            target: {
              name: options.total.param,
              value: data.total.value,
              others: others,
            },
          },
          false
        );
      } else {
        if (
          options?.depositTotal?.param &&
          !isNaN(parseInt(data?.depositTotal?.value))
        ) {
          //console.log('weee')
          const oldrelParam = currentFields.find(
            (x) => x.name === options.depositTotal.param
          );
          if (oldrelParam?.defaultValue !== data.depositTotal.value) {
            const oldValue = parseFloat(oldrelParam.defaultValue);
            const newValue = parseFloat(data.depositTotal.value);
            const currentDepositBalance = customerTotalDepositBalance.value;
            if (currentDepositBalance != null) {
              const customerDepositBalanceNewValue =
                currentDepositBalance - oldValue + newValue;

              handleChange(
                {
                  target: {
                    name: "contact_deposit_balance",
                    value: customerDepositBalanceNewValue,
                  },
                },
                false
              );

              setCustomerTotalDepositBalance((prev) => ({
                ...prev,
                value: customerDepositBalanceNewValue,
              }));
            }
            handleChange(
              {
                target: {
                  name: options.depositTotal.param,
                  value: data.depositTotal.value,
                },
              },
              false
            );
          }
        }
      }
    }
  }, [data]);
  useEffect(() => {
    const getCustomerTotalBalance = async (customerId) => {
      try {
        const response = await axios.get(
          `${config.apiUrl}/api/contacts/totalbalance?id=${customerId}&branchId=${branchId}`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Failed to fetch customer total balance:", error);
        return null;
      }
    };
    const getCustomerTotalDepositBalance = async (customerId) => {
      try {
        const response = await axios.get(
          `${config.apiUrl}/api/contacts/totaldepositbalance?id=${customerId}&branchId=${branchId}`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Failed to fetch customer total balance:", error);
        return null;
      }
    };

    const fetchData = async () => {
      const customerId = findDataInFields(
        currentFields,
        "contact.defaultValue"
      );

      if (!customerId) return;

      setCustomerTotalBalance({ loading: true, value: null });
      setCustomerTotalDepositBalance({ loading: true, value: null });

      const total = await getCustomerTotalBalance(customerId);
      const depositTotal = await getCustomerTotalDepositBalance(customerId);

      setCustomerTotalBalance({ loading: false, value: total });
      setCustomerTotalDepositBalance({ loading: false, value: depositTotal });
    };

    fetchData();
  }, []);
  const getReservationTotal = (subLists) => {
    // console.log(subLists, "sls");

    let total = 0;
    subLists.forEach((sublist) => {
      if (
        sublist.title === "Rent" ||
        sublist.title === "Extras" ||
        sublist.title === "Time adjustment" ||
        sublist.title === "Fines & Charges"
      ) {
        sublist.items.forEach((item, i) => {
          // if (item.title === "Discount") {
          //   total -= parseFloat(item.amount);
          // } else {
          // }
          if (
            item.adjustmentType === "" &&
            item.dateExtended != null &&
            item.dateExtended !== ""
          ) {
            const previousItemAddedDate =
              sublist.items.length > 1 && i !== 0
                ? sublist.items[i - 1].dateExtended
                : findDataInFields(currentFields, "return_date");

            if (new Date(previousItemAddedDate) > new Date(item.dateExtended)) {
              item.adjustmentType = "REDUCTION";
            } else {
              item.adjustmentType = "EXTENSION";
            }
          }
          if (
            item.deduct != null &&
            item.deduct !== "" &&
            (item.deduct === "true" || item.deduct === true)
          ) {
            // do not add anything since its not a charge
          } else if (
            item.adjustmentType != null &&
            item.adjustmentType === "REDUCTION"
          ) {
            total -= parseFloat(item.amount);
          } else {
            total += parseFloat(item.amount);
          }
        });
      }
    });
    return total;
  };
  const reservationTotal = getReservationTotal(initData().sublists);
  const discount = data.sublists.find(
    (subl) => subl.title === "Reservation bill"
  ).items[0];
  const tax = data.sublists.find((subl) => subl.title === "TAX").items[0];
  const fines = data.sublists.find((subl) => subl.title === "Fines & Charges");

  const getTotalAdditionalDiscount = (fines) => {
    let total = 0;
    fines.items.forEach((item) => {
      if (
        item.deduct != null &&
        item.deduct !== "" &&
        (item.deduct === "true" || item.deduct === true)
      ) {
        total += parseFloat(item.amount);
      }
    });
    return total;
  };

  const transactions = data.sublists.find(
    (subl) => subl.title === "Payments"
  ).items;
  const getTransactions = (transactions) => {
    let payments = [];
    let refunds = [];
    transactions.forEach((transaction) => {
      if (transaction.isRefund === true) {
        refunds.push(transaction);
      } else {
        payments.push(transaction);
      }
    });
    return { payments, refunds };
  };
  const groupValuesByTitle = (items) => {
    const result = {};

    items.forEach((item) => {
      const title = item.title;
      const amount = parseFloat(item.amount);

      // Initialize if the title is not already in the result
      if (!result[title]) {
        result[title] = {
          title: title,
          amount: 0,
          taxable: item.taxable,
        };
      }

      // Sum the amounts
      result[title].amount += amount;
    });

    // Convert result object to array
    return Object.values(result).map((item) => ({
      title: item.title,
      amount: item.amount.toFixed(2), // Optional: Format amount to 2 decimal places
      taxable: item.taxable,
    }));
  };

  const { payments, refunds } = getTransactions(transactions);
  const groupedPayments = groupValuesByTitle(payments);
  const groupedRefunds = groupValuesByTitle(refunds);
  const groupedFinesAndCharges = groupValuesByTitle(fines.items);
  return (
    <div className="grow">
      {data && (
        <div className="">
          {/* <div className="flex justify-end text-gray-500">
            <p className="text-[14px]">All figures in {currency}</p>
          </div> */}

          <div className="bottom-0 flex-none border-t border-gray-200 bg-gray-50  p-6 rounded-lg shadow">
            {data.mainTitle && (
              <div className="flex justify-between items-center ">
                <h2
                  id="summary-heading"
                  className="text-lg font-medium text-gray-900 "
                >
                  {data.mainTitle}
                </h2>
                <div className="text-lg font-medium text-gray-900">
                  ({currency})
                </div>
              </div>
            )}

            <dl className="mt-6 space-y-6 text-sm font-medium text-gray-500">
              {data.sublists &&
                Array.isArray(data.sublists) &&
                data.sublists.map((sublist, index) => {
                  if (sublist.title === "TAX") return;
                  if (sublist.title === "Payments") return;
                  if (
                    sublist.title === "Fines & Charges" &&
                    groupedFinesAndCharges.length > 0
                  ) {
                    return (
                      <React.Fragment key={Math.random() * 10123}>
                        <div className="flex justify-between">
                          <dt className="flex items-center gap-1 font-medium text-gray-800">
                            {sublist.title}
                          </dt>
                          <dd className="text-gray-900">
                            {/* {reservationTotal.toFixed(2)} */}
                          </dd>
                        </div>
                        {groupedFinesAndCharges != null &&
                          groupedFinesAndCharges.map((fine) => {
                            const fineTaxed = isTaxed(fine.taxable);
                            return (
                              <div
                                key={Math.random() * 10123}
                                className="flex justify-between items-center"
                                style={{ marginTop: 0 }}
                              >
                                <dt className="flex items-center gap-1.5 font-medium text-[#6b7280]">
                                  <span>{fine.title}</span>
                                  <span
                                    className={classNames(
                                      fineTaxed
                                        ? "text-green-700 bg-green-50 ring-green-600/20"
                                        : "text-gray-600 bg-gray-50 ring-gray-500/10",
                                      "rounded-md whitespace-nowrap px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
                                    )}
                                  >
                                    {fineTaxed ? "Taxed" : "Not Taxed"}
                                  </span>
                                </dt>
                                <dd className="text-gray-900">{fine.amount}</dd>
                              </div>
                            );
                          })}
                      </React.Fragment>
                    );
                  }
                  if (sublist.title === "Time adjustment") {
                    if (!sublist || !sublist.items?.length) return null;
                    const adjustDaysByDates = (items) => {
                      if (!Array.isArray(items)) return [];

                      return items.map((item, index) => {
                        const initialReturnDate = findDataInFields(
                          currentFields,
                          "return_date"
                        );

                        const prevDate =
                          index === 0
                            ? initialReturnDate.endsWith("Z")
                              ? initialReturnDate
                              : initialReturnDate + "Z"
                            : items[index - 1].dateExtended.endsWith("Z")
                            ? items[index - 1].dateExtended
                            : items[index - 1].dateExtended + "Z";

                        const currDate = item.dateExtended.endsWith("Z")
                          ? item.dateExtended
                          : item.dateExtended + "Z";

                        const diffDays = calculateDateDiff(
                          prevDate,
                          currDate,
                          2,
                          true
                        );
                        return {
                          ...item,
                          adjustmentType:
                            diffDays >= 0 ? "EXTENSION" : "REDUCTION",
                          title: Math.abs(diffDays).toString(),
                        };
                      });
                    };

                    // concat += calculateDateDiff(d1, d2);
                    const grouped = adjustDaysByDates(sublist.items).reduce(
                      (acc, item) => {
                        const type = item.adjustmentType || "OTHER";
                        if (!acc[type]) {
                          acc[type] = [];
                        }
                        acc[type].push(item);
                        return acc;
                      },
                      {}
                    );

                    return (
                      <div>
                        <div className="flex justify-between">
                          <dt className="flex items-center gap-1 font-medium text-gray-800">
                            {sublist.title}
                          </dt>
                        </div>

                        {Object.entries(grouped).map(
                          ([adjustmentType, items]) => {
                            const totalDays = items.reduce(
                              (sum, item) => sum + parseFloat(item.title || 0),
                              0
                            );
                            const totalAmount = items.reduce(
                              (sum, item) => sum + parseFloat(item.amount || 0),
                              0
                            );

                            return (
                              <div
                                className="flex justify-between"
                                key={adjustmentType}
                              >
                                <div className="flex gap-1 justify-between">
                                  <dt className="flex items-center gap-1 font-medium text-[#6b7280]">
                                    {adjustmentType === "EXTENSION"
                                      ? "Extension"
                                      : adjustmentType === "REDUCTION"
                                      ? "Reduction"
                                      : adjustmentType}
                                  </dt>
                                  <dt className="flex items-center gap-1 text-gray-500">
                                    {totalDays.toFixed(2)} days
                                  </dt>
                                </div>

                                <div className="flex justify-between">
                                  <dd className="text-gray-900">
                                    {totalAmount.toFixed(2)}
                                  </dd>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  }
                  // console.log(sublist, "sublist");
                  if (sublist.items.length === 0) return;

                  return (
                    <div key={index}>
                      <label
                        htmlFor={`discount-code-${index}`}
                        className="block text-sm font-medium text-gray-800"
                      >
                        {sublist.title}
                      </label>

                      {sublist.title === "Reservation bill" && (
                        <div
                          key={Math.random() * 10123}
                          className="flex justify-between"
                        >
                          <dt className="flex items-center gap-1 font-medium text-gray-500">
                            Reservation total
                          </dt>
                          <dd className="text-gray-900">
                            {reservationTotal.toFixed(2)}
                          </dd>
                        </div>
                      )}
                      {sublist.items.map((item, itemIndex) => {
                        if (item.title === "Cash surcharge") {
                          const branchCode = findDataInFields(
                            currentFields,
                            "branch.code"
                          );
                          // console.log(currentFields);

                          // console.log(field);
                          if (branchCode === "AE") {
                            return null;
                          }
                        }

                        return (
                          <div
                            key={itemIndex}
                            className={`flex justify-between ${
                              item.title === "Security deposit"
                                ? "text-[#1F2937]"
                                : "text-gray-500"
                            } `}
                          >
                            <dt className="flex items-center gap-1">
                              {item.title}{" "}
                              {item.daysCount != null && (
                                <div>
                                  (
                                  {(
                                    parseFloat(item.amount) /
                                    parseFloat(item.daysCount)
                                  ).toFixed(2)}
                                  /day)
                                </div>
                              )}
                            </dt>
                            <dd className="text-gray-900">
                              {parseFloat(item.amount).toFixed(2)}
                            </dd>
                          </div>
                        );
                      })}
                      {sublist.title === "Reservation bill" &&
                        discount != null &&
                        tax != null && (
                          <>
                            <div
                              key={Math.random() * 10123}
                              className="flex justify-between "
                            >
                              <dt className="flex items-center gap-1 font-medium text-gray-500">
                                Discounted total
                              </dt>
                              <dd className="text-gray-900">
                                {(
                                  reservationTotal -
                                  parseFloat(discount.amount) -
                                  getTotalAdditionalDiscount(fines)
                                ).toFixed(2)}
                              </dd>
                            </div>
                            <div
                              key={Math.random() * 10123}
                              className="flex justify-between"
                            >
                              <dt className="flex items-center gap-1">
                                {tax.title}
                              </dt>
                              <dd className="text-gray-900">
                                {parseFloat(tax.amount).toFixed(2)}
                              </dd>
                            </div>
                            <div
                              key={Math.random() * 10123}
                              className="flex justify-between border-b border-gray-200 pb-6"
                            >
                              <dt className="flex items-center gap-1 text-gray-500">
                                Reservation grand total
                              </dt>
                              <dd className="text-gray-900">
                                {(
                                  reservationTotal -
                                  parseFloat(discount.amount) -
                                  getTotalAdditionalDiscount(fines) +
                                  parseFloat(tax.amount)
                                ).toFixed(2)}
                              </dd>
                            </div>
                          </>
                        )}
                    </div>
                  );
                })}
              {groupedPayments.length > 0 && (
                <div className="border-t border-gray-200 pt-6">
                  <label className="block text-sm font-medium text-gray-800">
                    Payments
                  </label>
                  <div
                    style={{
                      marginTop: 0,
                    }}
                  >
                    {groupedPayments.map((p) => {
                      return (
                        <div
                          key={Math.random() * 10123}
                          className="flex justify-between"
                        >
                          <dt className="flex items-center gap-1">
                            {p.title}s
                          </dt>
                          <dd className="text-gray-900">{p.amount}</dd>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {groupedRefunds.length > 0 && (
                <div className="border-t border-gray-200 pt-6">
                  <label className="block text-sm font-medium text-gray-800">
                    Refunds
                  </label>
                  <div
                    style={{
                      marginTop: 0,
                    }}
                  >
                    {groupedRefunds.map((p) => {
                      return (
                        <div
                          key={Math.random() * 10123}
                          className="flex justify-between"
                        >
                          <dt className="flex items-center gap-1">
                            {p.title}s
                          </dt>
                          <dd className="text-gray-900">{p.amount}</dd>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {data.total && (
                <div>
                  <div className="flex items-center justify-between border-t border-gray-200 pt-6  text-gray-900">
                    <dt>{data.total.label}</dt>
                    <dd className="text-sm">{data.total.value}</dd>
                  </div>
                </div>
              )}
              {data.depositTotal && (
                <div className="flex items-center justify-between border-t border-gray-200 pt-6 text-gray-900">
                  <dt>{data.depositTotal.label}</dt>
                  <dd className="text-sm">{data.depositTotal.value}</dd>
                </div>
              )}
            </dl>
          </div>
        </div>
      )}
      <div className="mt-4 bg-gray-50  p-6 rounded-lg shadow max-md:mx-3">
        <div className="font-medium pb-2">Global balances</div>
        <div className="">
          <div key={Math.random() * 10123} className="flex justify-between ">
            <dt className="flex items-center gap-1 font-medium text-gray-800">
              Customer balance
            </dt>
            {customerTotalBalance.loading === true ? (
              "loading..."
            ) : (
              <div>
                {customerTotalBalance.value != null && (
                  <dd className="text-gray-900 font-medium">
                    {customerTotalBalance.value.toFixed(2)}
                  </dd>
                )}
              </div>
            )}
          </div>
          <div key={Math.random() * 10123} className="flex justify-between ">
            <dt className="flex items-center gap-1 font-medium text-gray-800">
              Customer deposit balance
            </dt>
            {customerTotalBalance.loading === true ? (
              "loading..."
            ) : (
              <div>
                {customerTotalDepositBalance.value != null && (
                  <dd className="text-gray-900 font-medium">
                    {customerTotalDepositBalance.value.toFixed(2)}
                  </dd>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryList;
